import { Box, Rating, Stack } from '@mui/material'
import { Button, Typography } from '@evocolabs/orkaui'
import joinCDN from '@/src/utils/CDN'
import Link from 'next/link'
import StarIcon from '@mui/icons-material/Star'
import styles from './styles.module.scss'
import { SectionTitle } from '../title'

interface Rating {
  value: number
  max?: number
}
interface ReviewProps {
  id: string
  rating: number | Rating
  content: string
  link: string
}

const data = {
  title: 'See What People Say About Orka Two',
  ctaText: 'Read Full Review',
  newsList: [
    {
      id: 'soundly',
      rating: 4,
      content:
        'Orka Two is one of the most exciting products to join the category in a long time. The product’s design is second to none, and the underlying technology is impressive.',
      link: 'https://www.soundly.com/product/orka-two#section-5'
    },
    {
      id: 'forbes',
      rating: { value: 9.7, max: 10 },
      content:
        'The Best Bluetooth Hearing Aids in 2024 with Seamless Bluetooth connectivity with both iOS and Android',
      link: 'https://www.forbes.com/health/l/best-hearing-aids-bluetooth'
    },
    {
      id: 'techlicious',
      rating: 3.5,
      content:
        'Their hearing correction yields natural, clear, and loud results. You get better-than-expected Bluetooth for music streaming and hands-free conversation.',
      link: 'https://www.techlicious.com/review/orka-two-otc-hearing-aids-excellent-sound-poor-battery-life'
    }
  ] as ReviewProps[]
}

const RATING_MAXIMUM = 5
function Review({ id, rating, content, link }: ReviewProps) {
  const [ratingValue, ratingMax] =
    typeof rating === 'number'
      ? [rating, RATING_MAXIMUM]
      : [rating.value, rating?.max ?? RATING_MAXIMUM]

  return (
    <Box className={styles.review}>
      {/* TODO: move logos to a general folder instead of specific folder for pages */}
      <img src={joinCDN(`/website/homepage/${id}.svg`)} height="75" alt={id} />
      <Box
        visibility={rating ? 'unset' : 'hidden'}
        display="flex"
        alignItems="center"
      >
        <Rating
          value={ratingValue}
          readOnly
          emptyIcon={<StarIcon style={{ opacity: 0.55, fontSize: '14px' }} />}
          sx={{ fontSize: '14px' }}
          precision={0.5}
        />
        <Typography
          variant="subtitle1"
          sx={{ ml: '8px' }}
        >{`${ratingValue}/${ratingMax}`}</Typography>
      </Box>
      <Stack justifyContent="space-between" alignItems="center" flex={1}>
        <Typography variant="body2" textAlign="center">
          {content}
        </Typography>
        <Link href={link} rel="noopener noreferrer" target="_blank">
          <Button
            variant="textprimary"
            icon
            id={`explore-orka-two-page-${id}-news`}
          >
            {data.ctaText}
          </Button>
        </Link>
      </Stack>
    </Box>
  )
}

function AffiliateReviews() {
  return (
    <Box className={styles['reviews-section']}>
      <SectionTitle>{data.title}</SectionTitle>
      <Box className={styles['reviews-section-content']}>
        {data.newsList.map(({ id, ...restProps }) => (
          <Review id={id} {...restProps} key={id} />
        ))}
      </Box>
    </Box>
  )
}

export default AffiliateReviews
